import { useEffect } from 'react';

import { useDispatch } from 'react-redux';

import styled from '@emotion/styled';

import { useAppSelector } from '../../shared/store';

import MainSectionInViewDispatcher
  from '../components/shared/MainSectionInViewDispatcher';
import { initializeMainSection } from '../slice';

const Container = styled.div`
  overflow-x: hidden;
`;

export default function MainSectionListContainer() {
  const { hasSession } = useAppSelector(({ auth }) => auth);
  const { sections } = useAppSelector(({ main }) => main);

  const dispatch = useDispatch();

  useEffect(() => {
    if (!hasSession) {
      return;
    }
    dispatch(initializeMainSection());
  }, [dispatch, hasSession]);

  return (
    <Container>
      {sections.map((section) => (
        <MainSectionInViewDispatcher
          key={section.id}
          section={section}
        />
      ))}
    </Container>
  );
}
